import { HeaderTabsComponent } from "@swivl-mono/ui";

import { NavBar } from "../../../../Models/NavBar/NavBar.Model";

const ContactCenterTitle = () => {
  return (
    <div className="flex items-center gap-8">
      <NavBar.Component.Title title="Contact Center" />
      <HeaderTabsComponent
        items={[
          { label: "Conversations", to: "/contact-center/conversations" },
          { label: "Recordings", to: "/contact-center/recordings" }
        ]}
      />
    </div>
  );
};

export default ContactCenterTitle;
